<template>
  <BaseModal ref="BaseModal" @confirm="confirm" @close="close">
    <!-- <template #moreBtns>
      <el-button type="primary" size="mini" @click="handleSaveTemplate"
        >保存模板</el-button
      >
      <el-button type="primary" size="mini" @click="handleCallTemplate"
        >调用模板</el-button
      >
    </template> -->
    <div class="select-base-amount-dialog">
      <SimpleTable
        width="25%"
        :showIndex="false"
        ref="tableLeft"
        :columns="columnsLeft"
        :data="tabs"
        @row-select="onRowSelectLeft"
      />
      <SimpleTable
        :loading="loading"
        width="75%"
        :showIndex="false"
        ref="tableRight"
        :columns="columnsRight"
        :data="tableDataRight"
      />
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords, addCbFn } from '@/utils/index'

export default {
  name: 'SelectBaseAmountDialog',
  components: { BaseModal, SimpleTable },
  props: {
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      options: {},
      columnsLeft: [{ field: 'label', title: '页签名称' }],
      columnsRight: [
        { field: 'name', title: '费用名称' },
        {
          field: 'checkFlag',
          title: '估算金额',
          canEdit: true,
          canModify: true,
          cellType: 'checkbox',
          multiple: true
        }
      ],
      tableDataRight: [],
      tableDataRightMap: {},
      currentSelectLeft: null,
      loading: false
    }
  },
  methods: {
    // 显示取费基数选择弹窗
    show(options = {}) {
      this.options = options
      this.tableDataRight = []
      this.tableDataRightMap = {}
      this.currentSelectLeft = null
      this.$refs.BaseModal.show({
        title: '取费基数',
        confirmText: '确定',
        width: '600px'
      })

      setTimeout(this.init)
    },

    // 初始化左侧页签表格
    init() {
      this.$refs.tableLeft.initialized()
    },

    // 切换页签后加载右侧可选费用
    onRowSelectLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      if (this.currentSelectLeft?.value === obj?.value || !obj) return
      this.currentSelectLeft = obj

      this.getRightTable()
    },

    // 获取当前页签下可作为取费基数的费用明细
    async getRightTable() {
      if (this.tableDataRightMap[this.currentSelectLeft.value]) {
        this.tableDataRight =
          this.tableDataRightMap[this.currentSelectLeft.value]
        return
      }
      this.loading = true
      const code = this.currentSelectLeft.url || this.currentSelectLeft.value
      const url = code.startsWith('/') ? code : `/${code}`
      const res = await this.$service.get(`${url}/list`, {
        mainId: this.options.id
      })
      this.loading = false
      const data =
        res?.data.map(e => ({
          name: e.costName || e.name,
          checkFlag: false
        })) || []
      data.push({ name: '合计', checkFlag: false })
      this.tableDataRightMap[this.currentSelectLeft.value] = sortRecords(data)
      this.tableDataRight = this.tableDataRightMap[this.currentSelectLeft.value]
    },

    getConfirmStr() {
      const res = []
      for (const [key, arr] of Object.entries(this.tableDataRightMap)) {
        const label = this.tabs.find(e => e.value === key)?.label
        arr
          .filter(e => e.checkFlag)
          .forEach(e => res.push(`${label}(${e.name})`))
      }
      return res.join('+')
    },

    // 确认选择并拼接取费基数字符串
    confirm(close) {
      const str = this.getConfirmStr()
      this.$emit('confirm', this.options.selectedCellInfos, str)
      close()
    },

    // 关闭弹窗时通知父组件
    close() {
      this.$emit('close')
    },

    async handleSaveTemplate() {
      const name = this.getConfirmStr()

      if (!name) {
        this.$message.warning('请至少勾选一条数据')
        return
      }

      this.$selectModal({
        title: '模板名称',
        type: 'input',
        confirm: this.saveTemplate.bind(this)
      })
    },
    async saveTemplate(name) {
      const res = await this.$service.post('/estimate-tab-template/save', {
        name,
        tabs: Object.keys(this.tableDataRightMap).map(k => ({
          name: k,
          costDetails: this.tableDataRightMap[k].map(e => ({
            name: e.name,
            checkedFlag: e.checkFlag
          }))
        }))
      })
      if (res.code === 200) {
        this.$message.success('保存成功')
      }
    },
    async handleCallTemplate() {
      const options = await this.$service.get('/estimate-tab-template/list')
      this.$selectModal({
        title: '调用模板',
        columns: [
          { field: 'name', canEdit: true, canModify: true, title: '名称' }
        ],
        options: options.data || [],
        menus: ['查询', '批量修改', '批量删除'],
        onModifyDataChangeTop: (getModifyData, cleanModifyData) => {
          addCbFn(
            this.$service,
            '/estimate-tab-template/batch',
            getModifyData,
            cleanModifyData
          )
        },
        allowMultiSelect: false,
        confirm: (selectedCellInfos, res) => {
          this.setBaseTemplateData(res[0])
        }
      })
    },

    async setBaseTemplateData(row) {
      const res = await this.$service.get(
        '/estimate-tab-template/detail/' + row.id
      )

      // 清空
      Object.values(this.tableDataRightMap).forEach(e => {
        e.forEach(e2 => {
          e2.checkFlag = false
        })
      })

      for (const item of res.data.tabs) {
        this.$set(
          this.tableDataRightMap,
          item.name,
          item.costDetails.map(e => ({
            name: e.name,
            checkFlag: e.checkedFlag
          }))
        )
        this.tableDataRight =
          this.tableDataRightMap[this.currentSelectLeft.value]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.select-base-amount-dialog {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  height: 350px;
}
</style>
